import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import rtkQueryErrorLogger from './rtkquery-middleware';
import baseApiSlice from './utilities/api/baseApiSlice';

const createStore = (preloadedState) =>
  configureStore({
    reducer: {
      [baseApiSlice.reducerPath]: baseApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(baseApiSlice.middleware, rtkQueryErrorLogger),
    preloadedState,
  });

const store = createStore();

setupListeners(store.dispatch);
export default store;
export { createStore };
